import { CallingState, useCall, useCallStateHooks } from "@stream-io/video-react-sdk";
import { FaMicrophone, FaMicrophoneSlash, FaPause, FaVideo, FaVideoSlash } from "react-icons/fa6";
import { IoCallSharp } from "react-icons/io5";
import { MdCallEnd } from "react-icons/md";


export const HangUpCallButton = () => {
    const call = useCall();

    const onCallHangupHandler = async () => {
        await call?.endCall();
    };

    return (
        <button
            onClick={onCallHangupHandler}
            className="p-2 bg-red-600 rounded-full hover:bg-red-500 transition-colors"
        >
            <MdCallEnd className="h-6 w-6 text-white" />
        </button>
    )
}


export const AcceptCallButton = () => {
    const call = useCall();

    const onCallAcceptHandler = async () => {
        await call?.join();
    };

    return (
        <button
            onClick={onCallAcceptHandler}
            className="p-2 bg-green-500 rounded-full hover:bg-green-700 transition-colors"
        >
            <IoCallSharp className="h-6 w-6 text-white" />
        </button>
    )
}


export const RejectCallButton = () => {
    const call = useCall();

    const onCallRejectHandler = async () => {
        const reason = call.isCreatedByMe ? "cancel" : "decline";
        await call?.leave({ reject: true, reason });
    };

    return (
        <button
            onClick={onCallRejectHandler}
            className="p-2 bg-red-600 rounded-full hover:bg-red-500 transition-colors"
        >
            <MdCallEnd className="h-6 w-6 text-white" />
        </button>
    )
}

export const ToggleAudioButton = () => {
    const call = useCall();
    const { useMicrophoneState, useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState()
    const { status } = useMicrophoneState();

    const shouldDisable = [CallingState.RINGING, CallingState.JOINING].includes(callingState)

    const toggleAudioMuted = async () => {
        await call?.microphone.toggle();
    };

    return (
        <button
            disabled={shouldDisable}
            onClick={toggleAudioMuted}
            className={`p-2 ${shouldDisable && 'opacity-55'} rounded-full ${status === "disabled" ? 'bg-red-600 hover:bg-red-500' : shouldDisable ? 'bg-gray-600' : 'bg-customGray hover:bg-gray-500'}`}
        >
            {(status === "disabled" || shouldDisable) ? <FaMicrophoneSlash className="h-6 w-6 text-white" /> : <FaMicrophone className="h-6 w-6 text-white" />}
        </button>
    )
}

export const ToggleVideoButton = () => {
    const call = useCall();
    const { useCameraState, useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState()
    // const customData = useCallCustomData();
    // const { type } = customData;
    const { status } = useCameraState();

    const shouldDisable = [CallingState.RINGING, CallingState.JOINING].includes(callingState)


    const toggleVideoMuted = async () => {
        await call?.camera.toggle();
    };


    return (
        <button
            disabled={shouldDisable}
            onClick={toggleVideoMuted}
            className={`p-2 ${shouldDisable && 'opacity-55'} rounded-full ${status === "disabled" ? 'bg-red-600 hover:bg-red-500' : shouldDisable ? 'bg-gray-600' : 'bg-customGray hover:bg-gray-500'}`}
        >
            {(status === "disabled" || shouldDisable) ? <FaVideoSlash className="h-6 w-6 text-white" /> : <FaVideo className="h-6 w-6 text-white" />}
        </button>
    )
}


export const CallControl = () => {

    return (
        <div className="flex justify-between bg-customGray rounded-lg p-4 w-full shadow-lg mt-auto z-50">
            <button
                className={`p-2 rounded-full 'bg-customDark hover:bg-gray-500'`}
            >
                <FaPause className="h-6 w-6 text-white" />
            </button>

            <ToggleAudioButton />

            <ToggleVideoButton />
            <HangUpCallButton />
        </div>
    )
}